import { observer } from "mobx-react";
import * as React from "react";
import { AudioNodeStore } from "../../../stores";
import { ResizableNodeView } from "../ResizableNodeView";
import { TopBar } from "../TopBar";
import "../NodeView.scss";
import "./AudioNodeView.scss";

interface AudioNodeViewProps {
    store: AudioNodeStore;
}

/**
 * This class represents the view for an audio node.
 * It extends ResizableNodeView to support interactive resizing
 * while displaying audio content sourced from the node store.
 */
@observer
export class AudioNodeView extends ResizableNodeView<AudioNodeStore> {

    /**
     * This getter method returns the CSS class name for the audio node.
     * @returns Class name for the audio node container.
     */
    protected getNodeClassName(): string {
        return "audioNode";
    }

    /**
     * This method renders the visual content of the audio node, 
     * including the top bar.
     * @returns Node representing the audio node content
     */
    protected renderContent(): React.ReactNode {
        const { store } = this.props;

        return (
            <>
                <TopBar store={store} />

                <div className="content audio-content">
                    <audio controls src={store.url} />
                </div>
            </>
        );
    }
}